module.exports = "#define GLSLIFY 1\nattribute vec3 position;\nvoid main(void){\n  gl_Position = vec4(position, 1.0);\n}\n"